export default {
  title: 'ExpertOrder',
  form: {
    api_key: {
      label: 'Chave API',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    error: 'Falha ao guardar alterações',
    success: 'Alterações guardadas',
  },
  connected: {
    title: 'ExpertOrder está ligado',
    description: 'Esta integração está configurada.',
  },
};
